import React from "react";
import { generateCRUDRoutes } from "../../../utils/index";

import Store from "./index";
import { ShoppingBag } from "lucide-react";


const storeRoutes = [	
    generateCRUDRoutes({
        mainTitle: "HyVid Store",
        basePath: "hyvid-store",
        mainComponent: <Store />,
        layout: "/console",	   
        icon: <ShoppingBag className="icon-item" />,
        subTitle:"HyVid Store",
        level:5,
        moduleId: 0,
    })
]

export default storeRoutes;